import React, { useState, useEffect } from "react";
import CommentReportGeneralInfo from "../GeneralInfo";
import CardContainer from "../../../../components/Common/CardContainer";
import ButtonInput from "../../../../components/Common/ButtonInput";
import * as BootstrapVariants from "../../../../constants/Bootstrap/Variants";
import * as GlobalSubmitUIDelay from "../../../../constants/AppBehaviour/globalSubmitUIDelay";
import { API, graphqlOperation } from "aws-amplify";
import { toast } from "react-toastify";
import PagePreLoad from "../../../../components/Common/PagePreLoad";
import { getReport } from "../../../../graphql/queries";
import { updateReport } from "../../../../graphql/mutations";
import { Form, Alert } from "react-bootstrap";
import CommentDetails from "../../Comments/Details";

const CommentReportDetails = (props) => {
  const [reportedCommentId, setReportedCommentId] = useState(null);
  const [commentReportData, setCommentReportData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [formSubmitInProgress, setFormSubmitInProgress] = useState(false);
  const [generalError, setGeneralError] = useState("");

  useEffect(() => {
    getCommentReportData();
  }, []);

  const getCommentReportData = async () => {
    try {
      const result = await API.graphql(
        graphqlOperation(getReport, { id: props.match.params.commentReportId })
      );

      const { reportCommentId } = result.data.getReport;

      // keep state
      setCommentReportData(result);
      setReportedCommentId(reportCommentId);
    } catch (error) {
      toast.error(
        `Error while fetching comment report data ${JSON.stringify(error)}`
      );
    }
  };

  // make sure we load the page after the state for counts are updated
  useEffect(() => {
    if (reportedCommentId) setIsLoading(false);
  }, [reportedCommentId]);

  const handleReturn = () => {
    props.history.push(`/commentReports`);
  };

  const handleProfaneRedirect = () => {
    props.history.push(
      `/commentReports/${props.match.params.commentReportId}/comments/profane/${reportedCommentId}`
    );
  };

  const handleDeleteRedirect = () => {
    props.history.push(
      `/commentReports/${props.match.params.commentReportId}/comments/delete/${reportedCommentId}`
    );
  };

  const markAsAcknowledged = async (event) => {
    event.preventDefault();
    setFormSubmitInProgress(true);
    try {
      let input = {
        id: props.match.params.commentReportId,
        isAcknowledged: true,
      };
      let marAsAcknowledgedResult = await API.graphql(
        graphqlOperation(updateReport, { input })
      );

      setTimeout(function () {
        toast.success(`Comment Report marked as Acknowledged`);
        handleReturn();
      }, GlobalSubmitUIDelay.DefaultDelay);
    } catch (error) {
      let errorMessage = `Error while updateing user report, ${JSON.stringify(
        error,
        null,
        2
      )}`;
      toast.error(errorMessage);
      setGeneralError(errorMessage);
      setFormSubmitInProgress(false);
    }
  };

  return (
    <PagePreLoad isLoading={isLoading}>
      <Form onSubmit={markAsAcknowledged} noValidate>
        <CardContainer
          header={"Comment Report Details"}
          backButton={
            <ButtonInput
              label="Back to List"
              type="button"
              variant={BootstrapVariants.OutlineSecondary}
              onClick={() => handleReturn()}
            />
          }
          submitButton={
            <ButtonInput
              label="Mark as Acknowledge"
              variant={BootstrapVariants.Success}
              formSubmitInProgress={formSubmitInProgress}
              formSubmittingText={"In Progress..."}
            />
          }
        >
          {generalError && (
            <Alert variant={BootstrapVariants.Danger}>{generalError}</Alert>
          )}
          <CommentReportGeneralInfo
            providedModelData={commentReportData}
            commentReportId={props.match.params.commentReportId}
          />
        </CardContainer>
      </Form>
      <CardContainer
        header={"Reported Comment"}
        backButton={
          <ButtonInput
            label="Back to List"
            type="button"
            variant={BootstrapVariants.OutlineSecondary}
            onClick={() => handleReturn()}
          />
        }
        extraButtons={
          <>
            <ButtonInput
              label="Mark As Profane"
              variant={BootstrapVariants.Dark}
              onClick={() => handleProfaneRedirect()}
            />
            <ButtonInput
              label="Delete Comment"
              style={{ marginLeft: "5px" }}
              variant={BootstrapVariants.Danger}
              onClick={() => handleDeleteRedirect()}
            />
          </>
        }
      >
        <CommentDetails {...props} commentId={reportedCommentId} />
      </CardContainer>
    </PagePreLoad>
  );
};

export default CommentReportDetails;
